import {
  ShareRestoredSubscription,
  useShareRestoredSubscription,
} from 'gqlTypes'
import { ErrorHandler } from 'modules/tracing'

import { handleShareRestored } from '../handlers'
import { SubscriptionEventHandler } from './types'

export interface ShareRestoredPayload {
  share: NonNullable<
    NonNullable<ShareRestoredSubscription['shareRestored']>['share']
  >
}

export interface UseShareRestoredProps {
  /**
   * handler which is called _before_ share is removed/added from/to the cache
   * it is possible to use this handler to update the UI state if it is
   * necessary
   */
  onShareRestored?: SubscriptionEventHandler<ShareRestoredPayload>
}

export const useShareRestored = (props: UseShareRestoredProps = {}) => {
  const { onShareRestored } = props

  useShareRestoredSubscription({
    onSubscriptionData: ({ subscriptionData, client }) => {
      const share = subscriptionData.data?.shareRestored.share
      if (!share) {
        ErrorHandler.shouldNeverHappen(
          `missing useShareRestored payload, ${JSON.stringify(
            subscriptionData
          )}`
        )
        return
      }

      try {
        onShareRestored?.({ share, client })
      } catch (e) {
        ErrorHandler.shouldNeverHappen(
          `onShareRestored should not throw errors, ${JSON.stringify(e)}`
        )
      } finally {
        handleShareRestored({
          cache: client,
          identifier: share.identifier,
        })
      }
    },
  })
}
